import {
  BottomSheetElementResult,
  Typenames,
} from '@varo/graphql-schema-types';
import buttonComponent from 'shared/legacySDUIAdapters/buttonComponent';
import fullWidthTextComponent from 'shared/legacySDUIAdapters/fullWidthTextComponent';
import vxlHairline from 'shared/legacySDUIAdapters/vxlHairline';
import vxlSpacing from 'shared/legacySDUIAdapters/vxlSpacing';
import { VXLNode } from 'shared/renderer/types';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';
import { Maybe } from 'shared/utils/types';

import { BorrowingPowerDependencies } from './types';

export function bottomSheetElementResult(
  element: BottomSheetElementResult,
  index: number,
  dependencies: BorrowingPowerDependencies,
): VXLNode | null {
  if (element.__typename === Typenames.FullWidthTextComponent) {
    return fullWidthTextComponent(element);
  } else if (element.__typename === Typenames.SpacingComponent) {
    return vxlSpacing(element, index);
  } else if (element.__typename === Typenames.VXLHairlineComponent) {
    return vxlHairline(element);
  } else if (element.__typename === Typenames.ButtonComponent) {
    return buttonComponent(element, dependencies);
  }

  return null;
}

function bottomSheetElementResults(
  elements: Maybe<Array<BottomSheetElementResult>>,
  dependencies: BorrowingPowerDependencies,
): VXLNode[] {
  return (
    elements
      ?.map((element, index) =>
        bottomSheetElementResult(element, index, dependencies),
      )
      ?.filter(isNotNil) ?? []
  );
}

export default bottomSheetElementResults;
